import { ProviderType } from "../../services/cloudchipr.api";

export const PROVIDERS: ProviderType[] = ["aws", "azure", "gcp"];
